<template>
  <div class="vm-todo-box">
    <div class="fwb tit fs24">
      <slot name="tit">{{$t('c.Todo.text1')}}</slot>
    </div>
    <div class="item-list">
      <div
        class="item-box flex-box flex-align-items-center flex-justify-content-space-between"
        v-for="(item, i) in todo_list"
        :key="i"
        :class="{on: item.status}"
        @click="action(item.key)"
      >
        <div class="flex-box flex-align-items-center">
          <i v-if="item.status == 1" class="afd afd-reached"></i>
          <span v-else class="mr16 black-5">···</span>
          <span class="text">{{item.name}}</span>
        </div>
        <i class="afd afd-arrow-right black-5"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "todo",
  props: {
    todo_list: {
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      // list: [
      //   {
      //     key: "upload_cover",
      //     name: "传一张封面图",
      //     status: 0
      //   },
      //   {
      //     key: "publish_post",
      //     name: "发一条动态",
      //     status: 0
      //   },
      //   {
      //     key: "add_payout",
      //     name: "填写提现方式",
      //     status: 0
      //   },
      //   {
      //     key: "share_page",
      //     name: "分享你的创作主页",
      //     status: 0
      //   },
      //   {
      //     key: "add_goal",
      //     name: "先定一个小目标",
      //     status: 0
      //   }
      // ]
    };
  },
  computed: {
    ...mapState("app", ["session_user", "browser_size"])
  },
  mounted() {
    
  },
  beforeDestroy() {
  },
  methods: {
    action(key) {
      if (key == "upload_cover") {
        this.$mixin_router_push("/setting/creator");
      }
      if (key == "publish_post" || key == "publish_sponsor_post") {
        if(this.GL.ENV.is_afd_client){
            this.$mixin_router_push('/compose','','', '1');
            return false;
        }
        this.$mixin_show_modal_feed();
      }
      if (key == "add_payout") {
        this.$mixin_router_push("/setting/withdraw");
      }
      if (key == "share_page") {
        this.$mixin_router_push(`/a/${this.session_user.url_slug}`);
      }
      if (key == "add_goal") {
        this.$mixin_router_push("/setting/goal");
      }
      if (key == "send_msg") {
        this.$mixin_router_push("/message");
      }
      if (key == "like_post" || key == "comment_post") {
        this.$mixin_router_push("/feed");
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-todo-box {
  background: $white;
  padding: px2rem(24) px2rem(24) px2rem(12) px2rem(24);
  box-shadow: $layer-box-shadow;
  box-sizing: border-box;

  .afd-reached {
    color: $success;
    margin-right: px2rem(16);
  }

  .item-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: px2rem(12);
    margin-left: _px2rem(12);
  }

  .item-box {
    width: 50%;
    padding: px2rem(12);
    box-sizing: border-box;

    &:hover {
      background: $black-03;
      cursor: pointer;
    }

    &.on {
      .text {
        text-decoration: line-through;
        color: $black-3;
      }

      .afd-arrow-right {
        display: none;
      }
    }
  }

  @media (max-width: $width-mobile) {
    padding: px2rem(24) px2rem(24) px2rem(12) px2rem(24);

    .item-list {
      margin-left: 0;
    }

    &:hover {
      background: $white;
    }

    .item-box {
      width: 100%;
      padding: px2rem(12) 0;
    }
  }
}
</style>
